// @ts-nocheck
import { Outlet } from 'react-router-dom';
import PendoPageTracker from '../components/Analytics/PendoPageTracker';

/**
 * Root Layout Component
 *
 * Wraps all routes and provides global components like PendoPageTracker
 * that need access to router context.
 */
const RootLayout = () => {
  return (
    <>
      <PendoPageTracker />
      <Outlet />
    </>
  );
};

export default RootLayout;
